declare global {
    interface Window {
        CryptoJS: any;
    }
}

const CryptoJS = window.CryptoJS;

const key = 'muumuumuumuumuumuumuumumumuumuum';
const iv = 'mumumuumumumumum';

/**
 * 加密
 */
export function encrypt(text: string) {
    return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
}

/**
 * 解密
 */
export function decrypt(text: string) {
    const result = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return result.toString(CryptoJS.enc.Utf8);
}

/**
 * example
 */
// const text="https://www.umu.com";
// const encoded=encrypt(text)

// console.log(encoded.toString());
// console.log(decrypt(encoded))
